import { createGlobalStyle } from "styled-components";

// Tokens (CSS vars) — fonte da verdade do design system (sub-projeto C-1)
import "./tokens.css";

// Fontes auto-hospedadas via @fontsource (self-host, sem Google Fonts — DEV-338).
// Source Sans 3 é a fonte do DS v2 (--font-sans / --font-display / --font-body).
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/600.css";
import "@fontsource/source-sans-3/700.css";
import "@fontsource/source-sans-3/400-italic.css";
// JetBrains Mono ainda usado por Carlão e AdditionRequest (legado).
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

const GlobalStyles = createGlobalStyle`

  /* CSS Reset */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  html { scroll-behavior: smooth; }

  body {
    font-family: var(--font-body);
    font-size: var(--fs-body);
    line-height: var(--lh-normal);
    color: var(--fg-1);
    background-color: var(--bg);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4 {
    font-family: var(--font-display);
    color: var(--fg-1);
    line-height: var(--lh-tight);
    margin: 0;
  }
  h1 { font-size: var(--fs-display); font-weight: var(--fw-bold); }
  h2 { font-size: var(--fs-h2);      font-weight: var(--fw-bold); }
  h3 { font-size: var(--fs-h3);      font-weight: var(--fw-bold); }
  h4 { font-size: var(--fs-h4);      font-weight: var(--fw-bold); }

  p { margin: 0; color: var(--fg-2); line-height: var(--lh-normal); }

  .lead {
    font-size: var(--fs-lead);
    color: var(--fg-3);
    line-height: var(--lh-snug);
  }

  .eyebrow {
    font-family: var(--font-body);
    font-weight: var(--fw-bold);
    font-size: var(--fs-2xs);
    letter-spacing: var(--tracking-eyebrow);
    text-transform: uppercase;
    color: var(--fg-4);
  }

  .meta-caps {
    font-weight: var(--fw-bold);
    font-size: var(--fs-xs);
    letter-spacing: var(--tracking-meta);
    text-transform: uppercase;
    color: var(--fg-4);
  }

  code, pre, .code {
    font-family: var(--font-mono);
    font-size: var(--fs-sm);
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* Global box-sizing */
  *, *:before, *:after {
    box-sizing: border-box;
  }

  /* Inputs/buttons herdam a font-body */
  button, input, textarea, select {
    font-family: var(--font-body);
    font-weight: var(--fw-regular);
  }

  /* Focus outline */
  *:focus {
    outline: 0;
  }

  /* Links */
  a {
    text-decoration: none;
    color: inherit;
  }

  /* Buttons */
  button {
    cursor: pointer;
    border: none;
    background: none;
  }

  /* Scrollbar */
   ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.gray};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.textGray};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.primary};
  }

 .react-datepicker-wrapper {
    width: 100% !important;
    display: block !important;
  }

  .react-datepicker__input-container {
    width: 100% !important;
    display: block !important;
  }

  /* --- POPUP FLUTUANTE (POSICIONAMENTO) --- */
  .react-datepicker-popper {
    z-index: 9999 !important;
    padding-top: 10px !important;
  }

  /* --- MAIN CALENDAR CONTAINER --- */
  .react-datepicker {
    font-family: inherit !important;
    border: 1px solid #dee2e6 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    background-color: white !important;
  }

  /* --- HEADER --- */
  .react-datepicker__header {
    background-color: #f3953f !important;
    border-bottom: none !important;
    border-radius: 8px 8px 0 0 !important;
    padding-top: 0.75rem !important;
  }

  .react-datepicker__current-month,
  .react-datepicker__day-name {
    color: #ffffff !important;
    font-weight: 600 !important;
  }

  /* --- DIAS --- */
  .react-datepicker__day {
    color: #495749ff !important;
    border-radius: 4px !important;
    transition: all 0.2s ease !important;

    &:hover {
      background-color: #fff3e6 !important;
      color: #f3953f !important;
    }
  }

  /* --- DIAS SELECIONADOS --- */
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: #f3953f !important;
    color: #ffffff !important;
    font-weight: 600 !important;

    &:hover {
      background-color: #e8863a !important;
    }
  }

  /* --- INTERVALO (RANGE) --- */
  .react-datepicker__day--in-range {
    background-color: #fff3e6 !important;
    color: #f3953f !important;
  }

  /* --- DIAS DESABILITADOS --- */
  .react-datepicker__day--disabled {
    color: #ced4da !important;
    cursor: not-allowed !important;

    &:hover {
      background-color: transparent !important;
    }
  }

  /* --- NAVIGATION (ARROWS) --- */
  .react-datepicker__navigation {
    top: 0.75rem !important;
  }

  .react-datepicker__navigation-icon::before {
    border-color: #ffffff !important;
  }

  .react-datepicker__navigation:hover *::before {
    border-color: #f8f9fa !important;
  }

  /* --- REMOVE TRIANGLE --- */
  .react-datepicker__triangle {
    display: none !important;
  }

  /* =================================================================
     REACT-TOASTIFY — alinhamento ao design system
     ------------------------------------------------------------------
     Estratégia: fundo levemente tintado por tipo (Sonner-style) +
     borda na mesma família de cor, texto fg1 sempre. Mantém Status
     Tripartite (cor + ícone + label) e nenhum ban infringido.
     ================================================================= */

  /* Toast limpo (Sonner-style): ícone colorido + mensagem, sem botão fechar
     (auto-dismiss). --toast-color é definido por variante; fundo levemente
     tintado + borda na mesma família. Alinhamento por flex central. */
  .Toastify__toast-container {
    padding: 12px;
    width: auto;
    min-width: 300px;
    max-width: 420px;
  }

  .Toastify__toast {
    --toast-color: ${({ theme }) => theme.colors.fg2};

    display: flex;
    align-items: center;
    gap: 12px;
    min-height: auto;
    padding: 14px 16px;
    font-family: ${({ theme }) => theme.typography.fontBody};
    font-size: ${({ theme }) => theme.typography.fs.sm};
    font-weight: ${({ theme }) => theme.typography.fw.semibold};
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.fg1};
    background: color-mix(in srgb, var(--toast-color) 8%, ${({ theme }) => theme.colors.surface});
    border: 1px solid color-mix(in srgb, var(--toast-color) 22%, ${({ theme }) => theme.colors.border});
    border-radius: ${({ theme }) => theme.radii.lg};
    box-shadow: ${({ theme }) => theme.shadows.card};
    overflow: hidden;
  }

  /* corpo: ícone + mensagem, centralizados verticalmente */
  .Toastify__toast-body {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
    margin: 0;
    padding: 0;
    color: inherit;
  }

  /* ícone colorido pela variante (sem badge — mais limpo/alinhado) */
  .Toastify__toast-icon {
    width: 22px;
    height: 22px;
    margin: 0;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--toast-color);
  }
  .Toastify__toast-icon svg {
    width: 22px;
    height: 22px;
    fill: none;
    stroke: currentColor;
  }

  /* barra de progresso (indicador do auto-dismiss) — fina e discreta */
  .Toastify__progress-bar {
    height: 3px;
    opacity: 0.9;
    background: var(--toast-color);
  }

  /* variantes: cor por tipo (Status Tripartite) */
  .Toastify__toast--success { --toast-color: ${({ theme }) => theme.colors.success}; }
  .Toastify__toast--error   { --toast-color: ${({ theme }) => theme.colors.error}; }
  .Toastify__toast--warning { --toast-color: ${({ theme }) => theme.colors.warning}; }
  .Toastify__toast--info    { --toast-color: ${({ theme }) => theme.colors.senneAccent}; }

  /* motion */
  .Toastify__slide-enter--top-right,
  .Toastify__slide-enter--top-center,
  .Toastify__slide-enter--top-left {
    animation-timing-function: ${({ theme }) => theme.motion.easeOut};
  }
`;

export default GlobalStyles;
